import { update } from '@kundinos/nanostores';

import { currentParametersStore } from './stores';

interface Params {
  groupId: number;
  variantId: number;
}

const selectParameter = ({ groupId, variantId }: Params): void => {
  update(currentParametersStore, (currentParameters) => {
    return currentParameters.map((parameter) => {
      if (parameter.groupId !== groupId) return parameter;

      return {
        ...parameter,
        variants: parameter.variants.map((variant) => ({
          ...variant,
          selected: variant.id === variantId,
        })),
      };
    });
  });
};

export default selectParameter;
